import ByteReader from "../../util/ByteReader";
export default class SWFByteReader extends ByteReader {
    /**
     * Reads RECORDHEADER from next tag in the buffer
     *
     * @return {Object} Tag code and length
     */
    readTagCodeAndLength() {
        let p = this.pointer;
        let n = this.readUInt16(), tagType = n >> 6, tagLength = n & 63 /* ReadMasks.RECORDHEADER_LENTH_FULL */;
        if (n === 0)
            return undefined;
        if (tagLength === 63 /* ReadMasks.RECORDHEADER_LENTH_FULL */)
            tagLength = this.readUInt32();
        return {
            start: p,
            end: this.pointer + tagLength,
            code: tagType,
            length: tagLength,
            position: this.pointer
        };
    }
    /**
     * Reads ACTIONHEADER from next tag in the buffer
     *
     * @return {Object} Tag code and length
     */
    readAction() {
        let s = this.pointer;
        let a = this.readUInt8();
        let l = (a & 0x80) ? this.readUInt16() : 0;
        let p = this.pointer;
        return {
            start: s,
            action: a,
            length: l,
            position: p
        };
    }
    /**
     * Reads RECT format
     *
     * @return {Object} x, y, width and height of the RECT
     */
    readRect() {
        this.start();
        let NBits = this.readBits(5), Xmin = this.readBits(NBits, true) / 20, Xmax = this.readBits(NBits, true) / 20, Ymin = this.readBits(NBits, true) / 20, Ymax = this.readBits(NBits, true) / 20;
        return {
            x: Xmin,
            y: Ymin,
            width: (Xmax > Xmin ? Xmax - Xmin : Xmin - Xmax),
            height: (Ymax > Ymin ? Ymax - Ymin : Ymin - Ymax)
        };
    }
}
